(() => {
  const HEADER_SEARCH_SCOPE = ".header__search";
  const TEMPLATE_SEARCH_SCOPE = ".template-search__search";
  const HEADER_CLEAR_KEY = "pandalino:clear-header-search";
  const TEMPLATE_CLEAR_KEY = "pandalino:clear-template-search";
  const SKU_QUERY_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)+$/i;
  const SKU_SEARCH_TYPE_SELECTOR = 'input[name="type"][data-pandalino-sku-search="true"]';

  function getSearchInputs(scope) {
    return document.querySelectorAll(`${scope} .search__input`);
  }

  function clearSearchInputs(scope) {
    getSearchInputs(scope).forEach((input) => {
      input.value = "";
      input.defaultValue = "";
      input.setAttribute("value", "");
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function applySkuSearchType(form) {
    const queryInput = form.querySelector('input[name="q"]');
    const managedTypeInput = form.querySelector(SKU_SEARCH_TYPE_SELECTOR);
    const query = queryInput ? queryInput.value.trim() : "";

    if (!SKU_QUERY_PATTERN.test(query)) {
      managedTypeInput?.remove();
      return;
    }

    const typeInput = managedTypeInput || document.createElement("input");
    typeInput.type = "hidden";
    typeInput.name = "type";
    typeInput.value = "product";
    typeInput.dataset.pandalinoSkuSearch = "true";

    if (!managedTypeInput) {
      form.appendChild(typeInput);
    }
  }

  function bindSearchForms(scope, storageKey) {
    document.querySelectorAll(`${scope} form[role="search"]`).forEach((form) => {
      if (form.dataset.pandalinoSearchBound === "true") return;
      form.dataset.pandalinoSearchBound = "true";

      form.addEventListener("submit", () => {
        applySkuSearchType(form);
        window.sessionStorage.setItem(storageKey, "true");
      });
    });
  }

  function clearAfterSearchIfNeeded(scope, storageKey) {
    if (window.sessionStorage.getItem(storageKey) !== "true") return;
    clearSearchInputs(scope);
    window.setTimeout(() => {
      clearSearchInputs(scope);
      window.sessionStorage.removeItem(storageKey);
    }, 120);
  }

  function clearTemplateSearchResultsInput() {
    const templateInput = document.querySelector("#Search-In-Template");
    if (!templateInput) return;

    templateInput.value = "";
    templateInput.defaultValue = "";
    templateInput.setAttribute("value", "");
    templateInput.dispatchEvent(new Event("input", { bubbles: true }));
    templateInput.dispatchEvent(new Event("change", { bubbles: true }));

    window.setTimeout(() => {
      templateInput.value = "";
      templateInput.defaultValue = "";
      templateInput.setAttribute("value", "");
    }, 120);
  }

  function flagMobileMenuViewAllLinks() {
    document.querySelectorAll(".menu-drawer__menu-item").forEach((item) => {
      const label = item.textContent.replace(/\s+/g, " ").trim().toLowerCase();
      if (label.startsWith("ver todo")) {
        item.classList.add("pandalino-menu-view-all");
      }
    });
  }

  function initPandalinoSearch() {
    bindSearchForms(HEADER_SEARCH_SCOPE, HEADER_CLEAR_KEY);
    bindSearchForms(TEMPLATE_SEARCH_SCOPE, TEMPLATE_CLEAR_KEY);
    clearAfterSearchIfNeeded(HEADER_SEARCH_SCOPE, HEADER_CLEAR_KEY);
    clearAfterSearchIfNeeded(TEMPLATE_SEARCH_SCOPE, TEMPLATE_CLEAR_KEY);
    clearTemplateSearchResultsInput();
    flagMobileMenuViewAllLinks();
  }

  document.addEventListener("DOMContentLoaded", initPandalinoSearch);
  document.addEventListener("shopify:section:load", initPandalinoSearch);
  window.addEventListener("pageshow", initPandalinoSearch);
  window.addEventListener("load", initPandalinoSearch);
})();
